<template>
  <v-app  >

      <!--
      <v-sheet
          color="primary"
          height="350"
          v-scroll="onScroll" 
          style="padding-top: 50px;padding-bottom: 20px;"
        >
                <v-card-text >

                 <v-skeleton-loader
                      :loading="loading"
                      height="200"
                      type="image"
                    >
                    <v-responsive>
                      <v-img
                        :src="require('../assets/images/social.png')"
                        class="newDeckImg"                        
                        height="200"
                      ></v-img>

                    </v-responsive>
                  </v-skeleton-loader>


                 

                          <span class="dinpro-medium white--text sheetHeader">Add new2 cards to your study decks</span>
                          
                     <v-btn
                            color="white"
                            depressed
                            @click="$router.push('cards')"
                            class="newCardBtn dinpro-medium elevation-0"
                            :style="'color:'+$vuetify.theme.primary"
                          >
                            Card Test 
                      </v-btn>

                   
                </v-card-text>



      </v-sheet>-->

      <v-main style="min-height: 500px"  class="scrolling-wrapper" >

        <!--
        <PlaylistVideoCard
          v-for="(video, index) in playlist.videos"
          :key="index"
          :video="video"
          @deleted="deletePlaylistVideo(video)"
        />-->



          <v-snackbar v-model="showOperationStatus" left>{{operationStatus}}</v-snackbar>

          <v-btn
              color="white"
              depressed
              @click="$router.push('create')"
              class="newCardBtn elevation-0"
              :style="'color:'+$vuetify.theme.primary"
          >
            Note it 
          </v-btn>


      <v-container class="d-block mx-auto" style="padding:8px" v-if="!addForm">

        <v-btn active-class="navActive" round center depressed flat  style="margin-top: 3px;width: 33vw !important;border-radius: 50px; " @click="testReload">       

         RELOAD

        </v-btn>
        <v-btn active-class="navActive" round center depressed flat  style="margin-top: 3px;width: 33vw !important;border-radius: 50px; " @click="testPerms">       

         ASK PERMS

        </v-btn>

      <!--  <vue-webrtc ref="webrtc" width="100%" roomId="sample-room">
        </vue-webrtc>-->
        <rtc-component ref="webrtc" width="100%" roomId="sample-room">
        </rtc-component>
        
        <v-card 
          class="d-flex align-center flex-column"
          style="height:125px;margin-bottom: 20px"         
          title="100 - 1000 USDT"
          text="This is content"
        >

        <div >
          <v-rating
            v-model="rating"
            bg-color="yellow-lighten-1"
            color="yellow-accent-4"
          ></v-rating>
          <pre>{{ rating }}</pre>
        </div>
                

        </v-card>


    <v-card style="height:125px;"   >
      <v-card-item>

        <v-card-title class="text-left" >USDT / CNY </v-card-title>

        <v-card-subtitle class="text-left"> 100 - 1000 USDT<v-icon color="lighten-1">mdi-wechat</v-icon></v-card-subtitle>

        <v-card-text class="float-right">asdf
          
        </v-card-text>
      

      </v-card-item>

      <v-card-text>

        <v-rating
            v-model="rating"
            bg-color="yellow-darken-1"
            color="yellow-accent-4"
          ></v-rating>
          <pre>{{ rating }}</pre>
      </v-card-text>
    </v-card>

<!--
      <GameCardsStack

        class="d-block"
        style="height:125px;margin-bottom: 20px"
        :cards="$store.state.tasks"
        @cardAccepted="handleCardAccepted"
        @cardRejected="handleCardRejected"
        @cardSkipped="handleCardSkipped"
        @hideCard="removeCardFromDeck"
            
      />



      <v-card dark color="#313035">

       <v-sheet class="pa-3">
         
        </v-sheet>

          <v-list three-line  class="records">
            <v-subheader>
              {{persons.length}} records
              <v-spacer></v-spacer>
              <v-btn  depressed color="primary" class="dinpro-medium" @click="loadCsv">load csv</v-btn>
            </v-subheader>
            <template v-for="(person, index) in persons" class="tList">
              <v-divider :inset="true" :key="index"></v-divider>

              <v-list-tile :key="'person'+index" avatar>
                <v-list-tile-avatar>
                  <img :src="person.avatar">
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="`${person.first_name} ${person.last_name}`"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="`Email: ${person.email}`"></v-list-tile-sub-title>
                  <v-list-tile-sub-title v-html="`IP: ${person.ip_address}`"></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple @click="deletePerson(person)">
                    <v-icon color="grey lighten-1">delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>-->
      </v-container>

    


    </v-main>

    
  </v-app>
</template>

<script>

//import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader' 

import PlaylistVideoCard from '../components/PlayListVideoCard.vue'
//import { VueWebRTC } from 'vue-webrtc'
 import RTC from '../components/RTC.vue'

export default {
  name: 'home',
  components: {
   // VSkeletonLoader,
    PlaylistVideoCard,
    'rtc-component': RTC
    //'vue-webrtc': VueWebRTC

  },

  data(){
    return {
      offsetTop: 30,
      showOperationStatus: false,
      operationStatus: '',
      loading: false,
      src: '../assets/images/social.png',
      addForm: false,
      group: null,
      rating: 3.5,
     
    }
  },
  computed: {
    playlist() {
      return {
          videos: [
            {
              id:'FnK6dyxUpyE',
              title: 'Draw a Cat',
              channel: 'StoryTime - Level 1'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title some title some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
            {
              id:'FnK6dyxUpyE',
              title: 'some title',
              channel: 'channel'
            },
          ],
        }//this.$store.state.playlist.currentPlaylist;
    },
  },
  methods:{
    testReload(){
      try{
        window.flutter_inappwebview.callHandler('laobu', {action:'reload'});
      }
      catch(e){
        alert(JSON.stringify(e))
      }
    },
    testPerms(){
      try{
        window.flutter_inappwebview.callHandler('laobu', {action:'permission', types: ['audio','video']});
      }
      catch(e){
        alert(JSON.stringify(e))
      }
    },
    onScroll (e) {
        //this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
    },
    deletePlaylistVideo(target) {
      this.$store.commit("playlist/removeFromPlaylist", {
        playlistIndex: this.playlist.index,
        video: target,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  a {
  -webkit-user-drag: none;
  }

  .study{    
     overflow-x: hidden;
  }
  
  .tList{
    display: block;
  }
  .addBtn{
    bottom: 5rem
  }
  .addForm{
    position: fixed;
    top: 0;
    left:0;
  
    width:100%;
    height: 100%;
    z-index: 2
  }
  .bottomSheet{
    background:#21ce99;


  }
  .newCardBtn{
    
    max-width:50vw;
    margin:0 auto;
    display: block;

  }
  .newDeckImg,.sheetHeader{
    display: block;
    margin:0 auto;

  }
  .sheetHeader{
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size:21px;
    font-weight: 100;

  }

.scrolling-wrapper {

  overflow-x: hidden;
  overflow-y: auto;
  max-height: 100vh;
  /*width: 600px;*/
  -webkit-overflow-scrolling: touch;
  padding-top: 20px;
  padding-bottom: 200px;


  .hItem {


  }

  &::-webkit-scrollbar {
    display: none;
  }
}

>>> .records{
  background: #313035;

}

 >>> .topicBadge{
  
    background:#222126;
    margin-left: 5px;
    margin-right: 0px;
    height: 24px !important;
    width: 24px !important;
    min-width: 24px;
}

/* always present */
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}



.slide-enter-active {

   transition-duration: 0.6s;

   transition-timing-function: ease-in;
}

.slide-leave-active {

   transition-duration: 0.6s;
   transition-timing-function: ease-out; /*cubic-bezier(0, 1, 0.5, 1);*/
}

.slide-enter-to, .slide-leave {
   max-height: 100vh;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}


.rating-values {
   width: 25px;
}



</style>